import { CalendarCheck, Clock, RefreshCw, Zap } from "lucide-react";
import { Reveal, SectionHead } from "./shared";

const FEATURES = [
    { num: "01", icon: Zap, title: "Answers Instantly", desc: "Every inquiry gets a fast response, even after hours." },
    { num: "02", icon: RefreshCw, title: "Follows Up Automatically", desc: "Stop losing leads because nobody followed up." },
    { num: "03", icon: CalendarCheck, title: "Books Appointments", desc: "Let your AI turn conversations into scheduled appointments." },
    { num: "04", icon: Clock, title: "Works 24/7", desc: "Your business keeps responding while you're sleeping, busy, or away." },
];

export default function Manifesto() {
    return (
        <section className="py-24 sm:py-32 relative" data-testid="manifesto-section">
            <div className="container-x">
                <SectionHead
                    eyebrow="01 — The Concept"
                    title="Imagine Having an Employee Who Never Sleeps."
                    sub="Your AI assistant handles the repetitive conversations that steal your time — so you can focus on running your business."
                    testid="manifesto-heading"
                />
                <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
                    {FEATURES.map((f, i) => (
                        <Reveal key={f.num} delay={i * 0.1}>
                            <div
                                className="glass card-hover rounded-3xl p-7 h-full relative overflow-hidden group"
                                data-testid={`manifesto-card-${f.num}`}
                            >
                                <div className="absolute -top-12 -right-12 w-32 h-32 bg-cyan-500/10 blur-3xl rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                                <span className="ff-mono text-xs text-slate-600">{f.num}</span>
                                <div className="mt-5 w-12 h-12 rounded-2xl bg-cyan-400/10 border border-cyan-400/25 flex items-center justify-center transition-transform duration-300 group-hover:scale-110">
                                    <f.icon className="w-5 h-5 text-cyan-300" />
                                </div>
                                <h3 className="mt-6 text-lg font-bold text-white tracking-tight">{f.title}</h3>
                                <p className="mt-3 text-sm text-slate-400 leading-relaxed">{f.desc}</p>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
